import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/core/app-config/app-config.service';
import { SampleService } from '../models/sample-service.model';
import { ReportTemplate } from '../models/report-template.model';
import { AccountsOrderingServiceResponse } from '../models/order-creation/accounts-ordering-service-response.model';
import { StandardCommentTemplate } from '../models/standard-comment-template.model';
import { SalesCatalogue} from '../models/sales-catalogue.model';

@Injectable({
  providedIn: 'root'
})
export class EolctDataService {


  constructor(
    private httpClient: HttpClient,
    private appConfigService: AppConfigService) {
  }
 

  getSampleServices(orderingServiceCode: string, receivingLabCode: string, cache = true): Observable<SampleService[]> {
    const apiUrl = `orderingServices/${orderingServiceCode}/receivingLabs/${receivingLabCode}/sampleServices`;
    return this.getData<SampleService[]>(apiUrl, cache);
  }

  getConfigurations(keys: string) {
    const apiUrl = this.appConfigService.configuration?.apiConfig.eolctQueryBaseUrl + `settings/configurations`;
    return this.httpClient.get(apiUrl, {
      params: {
        configurationKeys: keys
      }
    });
  }

  getFeatureFlags(keys: string) {
    const apiUrl = this.appConfigService.configuration?.apiConfig.eolctQueryBaseUrl + `settings/featureFlags`;
    const headers = new HttpHeaders({ 'cache-response': 'true' });
    return this.httpClient.get(apiUrl, {
      params: {
        flags: keys
      },
      headers
    });
  }

  getCommerialItemStandardComments(templateCode: string, cache = true): Observable<StandardCommentTemplate> {
    const apiUrl = `commercialItems/standardComments/${templateCode}`;
    return this.getData<StandardCommentTemplate>(apiUrl, cache);
  }

  private getData<T>(apiUrl: string, cache = false, loading = true): Observable<T> {
    const url = this.appConfigService.configuration?.apiConfig.eolctQueryBaseUrl + apiUrl;
    let headers: HttpHeaders;
    if (cache) {
      headers = new HttpHeaders({ 'cache-response': 'true' });
    }
    if (!loading) {
      headers = headers.append('no-loading', 'true');
    }
    return this.httpClient.get<T>(url, { headers });
  }

}
